"use client";

import React from "react";
import type { HeaderProviderContext } from "./types";

const HeaderContext = React.createContext<HeaderProviderContext | null>(null);

export default HeaderContext;
